// Initialisation Sentry (front joueur, CRA). Inactif tant que
// REACT_APP_SENTRY_DSN n'est pas défini — rien ne casse sans le compte,
// et @sentry/react est tree-shaké du bundle (zéro coût).
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;
const isDev = process.env.NODE_ENV !== 'production';

// ponytail: Sentry actif en prod uniquement — évite le bruit des erreurs de dev/hot-reload.
if (dsn && !isDev) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'development',
    initialScope: { tags: { app: 'joueur-front' } }, // projet Sentry partagé avec l'orga → distinguer la source
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing : 100% en dev, échantillonné en prod.
    tracesSampleRate: isDev ? 1.0 : 0.1,
    // Session Replay : 10% des sessions, 100% de celles avec erreur.
    // Note : coût réseau (cible mobile) — baisser si besoin batterie/data.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
    sendDefaultPii: true,
  });
}

export default Sentry;
